<div class="fullscreen-navigation-container">
    <!-- [title]="'Back to previous page'" -->
    @if (canNavigateBackward()) {
    <button
        mat-flat-button
        id="fullpage-nav-btn-back"
        class="fullpage-nav-btn fullpage-nav-btn-back"
        [disabled]="isBusy"
        (click)="previousSection(group)">
        <span class="">{{ backBtnTitle || 'Back' }}</span>
    </button>
    }

    <!-- [title]="'Continue to the next page'" -->
    @if (canNavigateForward()) {
    <button
        mat-flat-button
        id="fullpage-nav-btn-next"
        class="fullpage-nav-btn fullpage-nav-btn-next"
        color="primary"
        [disabled]="isBusy"
        (click)="nextSection(group)">
        <span class="">{{ okBtnTitle || 'Ok' }}</span>
    </button>
    }

    @if (canSubmit()) {
    <button
        mat-flat-button
        id="fullpage-nav-btn-submit"
        class="fullpage-nav-btn fullpage-nav-btn-submit"
        color="primary"
        [disabled]="isBusy"
        (click)="submitApplication()">
        <mat-icon [svgIcon]="'feather:upload-cloud'"></mat-icon>
        <span class="">{{ submitBtnTitle || 'Submit' }}</span>
    </button>
    }
</div>